import { playSample } from './audio'
import { GOAL_SUCCESS_SFX } from './missionSfx'
import { BehaviorHandler, HudStyle, MissionBehaviors } from './types'

/**
 * RJS11 のミッション環境ビヘイビア。
 *
 * テンプレート rbxl（src/missions/templates/RJS11.rbxl）のギミックを移植する:
 * - ServerScriptService/GameManager + StarterGui/GUILocalScript:
 *   BindableEvent「クリア」で ClearSound を再生し、TextLabel
 *   「ゲームクリア！」を 3 秒間表示して消す（Lua: Visible=true → wait(3) →
 *   Visible=false）。プレビューでは学習者コードの「メッセージを送る」が
 *   同名メッセージとして届く。
 *
 * プレビューでの近似・意図的な差異:
 * - クリアが連続で届いた場合、Lua は受信ごとに別コルーチンが
 *   「3 秒後に消す」を実行する（先着の消灯が後着の表示を一時的に消す）。
 *   ここでも同じ意味論（受信ごとに wait(3) → 非表示）で移植する。
 *
 * このミッションの他のスクリプト（①ボール / ②スイッチ / ③スタートちてん の
 * Script）はすべて学習者の Blockly プログラム対象のため移植しない。
 * Doge（犬のモデル）・Woods はスクリプトを持たない静的装飾。
 *
 * 未対応: なし（Tool・装備系のギミックはこのミッションに存在しない）。
 */

/** クリア表示を消すまでの秒数（Lua: GUILocalScript の wait(3)）。 */
const CLEAR_HIDE_SECONDS = 3

/** クリア GUI の文言（実機 TextLabel の Text）。 */
const CLEAR_TEXT = 'ゲームクリア！'

/** クリア GUI の実機デザイン（ScreenGui/TextLabel の実測値）。 */
const CLEAR_HUD_STYLE: HudStyle = {
  background: '#FFFF7F',
  color: '#FF0000',
  border: '#FFFFFF',
  borderWidth: 6,
  wide: true,
}

export const createRjs11Behaviors = (): MissionBehaviors => {
  const onMessage = new Map<string, BehaviorHandler>()

  // Lua: storage["クリア"].Event → ClearSound:Play() + ClearRemoteEvent →
  // GUILocalScript が TextLabel を 3 秒表示して消す。
  onMessage.set('クリア', async (ctx) => {
    playSample(GOAL_SUCCESS_SFX.url, GOAL_SUCCESS_SFX.volume, ctx.signal)
    ctx.setHudText?.(CLEAR_TEXT, CLEAR_HUD_STYLE)
    await ctx.wait(CLEAR_HIDE_SECONDS)
    // 停止（abort）時はランタイム側が HUD をクリアするため何もしない。
    if (!ctx.signal.aborted) {
      ctx.setHudText?.(null)
    }
  })

  return { onMessage }
}
